module.exports = "/images/vendor/flag-icon-css/flags/4x3/mp.svg?c5eb7f233b097ecfc5f78b3959907dcc";